import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../../config/api";
import Swal from "sweetalert2";
import swal from "sweetalert";
import { useMutation } from "react-query";
import SoapPasienAddNurse from "./Components/SoapPatients/Nurse/SoapAdd";
import SoapPasienAddDoctor from "./Components/SoapPatients/Doctor/SoapAdd";

const rolesData = JSON.parse(localStorage.getItem("roles")) || [];
const isNurse = rolesData.some((role) => role.name === "Nurse");
const isDoctor = rolesData.some((role) => role.name === "Doctor");

export default function ModalRoleAdd(props) {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [getData, setGetData] = useState(null);
  const [isDataExist, setIsDataExist] = useState(false);
  const idUser = rolesData[0]?.pivot?.id_user;
  const idRole = rolesData[0]?.pivot?.id_role;


  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const [form, setForm] = useState({
    id_patient: "",
    id_doctor: "",
    id_appointment: "",
    subjective: "",
    objective: "",
    assessment: "",
    planning: "",
    implementation: "",
    evaluation: "",
    note: "",
    create_by: "",
    update_by: "",
  });

  const GetResponseData = async () => {
    try {
      setLoading(true)
      const response = await API.get(
        `/transaction-service/soap-patients/${props?.idAppointmentModalSoapPatient}`,
        {
          ...fetchParams,
          params: {
            create_by: idUser,
            id_role: idRole
          }
        }
      );

      if (response?.status === 200) {
        const data = response.data.data;
        setGetData(data);
        setIsDataExist(!data);
        setForm({
          ...form,
          id_doctor: data?.id_doctor || props?.idDoctorModalSoapPatient,
          subjective: data?.subjective || "",
          objective: data?.objective || "",
          assessment: data?.assessment || "",
          planning: data?.planning || "",
          implementation: data?.implementation || "",
          evaluation: data?.evaluation || "",
          note: data?.note || "",
          create_by: data?.create_by || "",
          update_by: data?.update_by || "",
        });
      }
    } catch (error) {
      setIsDataExist(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetResponseData();
  }, []);


  const submitForm = async () => {
    try {
      setLoading(true);
      const response = await API.post(
        "/transaction-service/soap-patients/store",
        {
          id_patient: props?.idPatientModalSoapPatient,
          id_appointment: props?.idAppointmentModalSoapPatient,
          id_doctor: form?.id_doctor || props?.idDoctorModalSoapPatient,
          subjective: form?.subjective,
          objective: form?.objective,
          assessment: form?.assessment,
          planning: form?.planning,
          implementation: form?.implementation,
          evaluation: form?.evaluation,
          note: form?.note,
        },
        fetchParams
      );

      if (response?.status === 200) {
        swal({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 5000,
          buttons: false,
        });
        GetResponseData()
      }
    } catch (error) {
      swal({
        title: "Failed",
        text: `${error.response?.data?.message || "Something went wrong"}`,
        icon: "error",
        timer: 3000,
        buttons: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitUpdate = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const response = await API.put(
        `/transaction-service/soap-patients/${props.idAppointmentModalSoapPatient}`,
        {
          id_doctor: form?.id_doctor,
          id_patient: form?.id_patient || props.idPatientModalSoapPatient,
          id_appointment: form?.id_appointment || props.idAppointmentModalSoapPatient,
          id_role: form?.id_role || idRole,
          subjective: form?.subjective,
          objective: form?.objective,
          assessment: form?.assessment,
          planning: form?.planning,
          implementation: form?.implementation,
          evaluation: form?.evaluation,
          note: form?.note,
          create_by: form?.create_by,
        },
        fetchParams
      );

      if (response?.status === 200) {
        swal({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          buttons: false,
        });
        GetResponseData()
      }
    } catch (error) {
      swal({
        title: "Failed",
        text: `${error.response?.data?.message || "Update failed"}`,
        icon: "error",
        timer: 3000,
        buttons: false,
      });
    } finally {
      setLoading(false);
    }
  };


  const mutation = useMutation(submitForm);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (getData !== null) {
      handleSubmitUpdate(e);
    } 

    if (getData === null) {
      mutation.mutate();
    }
  };


  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      {isNurse && (
        <SoapPasienAddNurse
          props={props}
          form={form}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      )}

      {isDoctor && (
        <SoapPasienAddDoctor
          props={props}
          form={form}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      )}
    </>
  );
}

